export const enum IndividualDesignationListedTypes {
  BENEFICIARY = 'BENEFICIARY',
  EXECUTOR = 'EXECUTOR',
  TRUSTEE = 'TRUSTEE',
  NOTSURE = 'NOTSURE',
  EMPTY = '',
}
